import global_axios from '../funciones_globales/interaccionapi';

export const cargarParametros=(parametro,tipo)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/catalogos?tipo='+tipo+'&opcion='+parametro)
	    .then((response)=>{
            resolve(response.data.map(item => ({label: item.Codigo, value: item.Referencia}) ));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}

export const cargarCatalogos=(tipo)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/catalogos?tipo=tabla&opcion=' + tipo)
	    .then((response)=>{
            resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})`, descuento:item.ValorCuenta1, referencia:item.Referencia, observacion:item.Observacion })));//DSCTO PLAZO 2020-06-24
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}


export const cargarCatalogosBodega=(tipo)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/catalogos?tipo=BODEGASACT&opcion=' + tipo)
	    .then((response)=>{
            resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}


export const cargarCatalogos_Otros=(tipo)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
	    .then((response)=>{
            resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}

export const cargarCatalogos_OtrosConIndicador=(tipo)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
	    .then((response)=>{
            resolve(response.data.map(item => ({
                value: item.Codigo.toString().toUpperCase(),
                label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})`,
                indicador: item.Indicador
            })));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}


export const cargarCatalogosGenerico=(ruta)=> {
    return new Promise((resolve, reject) => {
        global_axios.get(ruta)
	    .then((response)=>{
            resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}

export const cargarCatalogosAsync=(tipo, parametro_busqueda, callback)=> {
    return global_axios.get('/catalogos?tipo=tabla&opcion=' + tipo + '&cadena_busq=' + parametro_busqueda)
    .then(response => response.data)
    .then(data => callback(null, {
        options: data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })),
        complete: true
    }))
    .catch((err)=>{
        console.log('Error al cargar datos de catálogos desde API: ' + err);
    });
} 

export const cargarCatalogosGenericoAsync=(ruta, query, callback)=> {
    return global_axios.get(ruta + query)
    .then(response => response.data)
    .then(data => callback(null, {
        options: data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })),
        complete: true        
    }))
    .catch((err)=>{
        console.log('Error al cargar datos de catálogos desde API: ' + err);
    });
} 

export const cargarCatalogosGenericoAsyncInvertido=(ruta, query, callback)=> {
    return global_axios.get(ruta + query)
    .then(response => response.data)
    .then(data => callback(null, {
        options: data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Codigo.toString().toUpperCase()} (${item.Descripcion.toString().toUpperCase()})` })),
        complete: true        
    }))
    .catch((err)=>{
        console.log('Error al cargar datos de catálogos desde API: ' + err);
    });
} 

export const cargarCatalogosAsyncDependiente=(tipo, ref, parametro_busqueda, callback)=> {
    return global_axios.get('/catalogos?tipo=tabla&opcion=' + tipo + '&referencia=' + ref +'&cadena_busq_alterna=' + parametro_busqueda)
    .then(response => response.data)
    .then(data => callback(null, {
        options: data.map(item => ({value: item.Observacion.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Observacion.toString().toUpperCase()})` })),
        complete: true
    }))
    .catch((err)=>{
        console.log('Error al cargar datos de catálogos desde API: ' + err);
    });
}

export const cargarCatalogosAsyncDobleDependiente=(tipo, ref, parametro, parametro_busqueda, callback)=> {
    return global_axios.get('/catalogos/?tipo=tabla&opcion='+ tipo + '&referencia=' + ref + '&observacion=' + parametro + '&cadena_busq_parroquia=' + parametro_busqueda)
    
    .then(response => response.data)
    .then(data => callback(null, {
        options: data.map(item => ({value: item.Nombre.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Nombre.toString().toUpperCase()})` })),
        complete: true
    }))
    .catch((err)=>{
        console.log('Error al cargar datos de catálogos desde API: ' + err);
    });
}

export const generarItemCatalogoSeleccionado=(value, label)=>{
    return { label: label.toString().trim() + ' (' + value.toString().trim() + ')',
             value: value.toString().trim()
    };
}



export const cargarCatalogoEstados=(tabla, campo)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/estados?tabla=' + tabla + '&campo=' + campo)
	    .then((response)=>{            
            resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos de estados desde API: ' + err);
        });
    });
}

export const cargarCatalogosBodegaFacturacion=(tipo)=> {//Willy 20191202
    return new Promise((resolve, reject) => {
        global_axios.get('/catalogos?tipo=BODEGASFAC&opcion=' + tipo)
	    .then((response)=>{
            resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}

export const cargarCatalogosBodegaPrincipales=(tipo)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/catalogos?tipo=BODEGASPR&opcion=' + tipo)
	    .then((response)=>{
            resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
        })
        .catch((err)=>{
            reject('Error al cargar datos de catálogos desde API: ' + err);
        });
    });
}